import { cuteToast } from "../UI/cute";


export default function validateInfo(values,type) {
    let errors = {};
    
    if(type === 'meeting'){
      if (!values.fullname) {
        errors.fullname = 'Fullname Required!';
      } 
      if (!values.buttontext) {
        errors.buttontext = 'Please Enter Button Text';
      } 
      
      if (!values.meetingLink) {
        errors.meetingLink = 'Meeting Link Required!';
      } 

    }else if(type === 'cta'){
      if(values.formtype && values.formtype === 'text'){
        if(!values.text){
          errors.text = 'CTA Text Required!';
        }

        if(!values.link){
          errors.link = 'Link Required!';
        }

        if(values.link && !validURL(values.link)){
          errors.link = 'Enter URL is Invalid.';
        }
      }

      if(values.formtype && values.formtype === 'image'){
        
        if(!values.image){
          errors.image = 'Please upload Image!';
        }

        if(!values.link){
          errors.link = 'Link Required!';
        }

        if(values.link && !validURL(values.link)){
          errors.link = 'Enter URL is Invalid.';
        }
      }

    }else if(type === 'annotation'){
      if(!values.annotationText){
        errors.annotationText = 'Text Required!'
      }

      if(!values.annotationLink){
        errors.annotationLink = 'Link Required!'
      }

      if(values.annotationLink && !validURL(values.annotationLink)){
        errors.annotationLink = 'Enter URL is Invalid.';
      }

      if(!values.annotationStartTime){
        errors.annotationStartTime = 'Start Time Required!'
      }

      if(!values.annotationEndTime){
        errors.annotationEndTime = 'End Time Required!'
      }

      if(values.annotationEndTime <= values.annotationStartTime){
        errors.annotationEndTime = 'End time should be greater than start time.'
      }

      // console.log(Date.parse(values.annotationEndTime), parseInt(values.annotationStartTime),errors)

    }else if(type === 'buybutton'){
      if(!values.buybuttonText){
        errors.buybuttonText = 'Text Required!'
      }

      if(!values.buybuttonLink){
        errors.buybuttonLink = 'Link Required!'
      }

      if(values.buybuttonLink && !validURL(values.buybuttonLink)){
        errors.buybuttonLink = 'Enter URL is Invalid.';
      }

      if(!values.buybuttonStartTime){
        errors.buybuttonStartTime = 'Start Time Required!'
      }

      if(!values.buybuttonEndTime){
        errors.buybuttonEndTime = 'End Time Required!'
      }

      if(values.buybuttonEndTime <= values.buybuttonStartTime){
        errors.buybuttonEndTime = 'End time should be greater than start time.'
      }

      // console.log(Date.parse(values.annotationEndTime), parseInt(values.annotationStartTime),errors)

    }else if(type === 'linkbutton2'){
      if(!values.linkbtnText){
        errors.linkbtnText = 'Text Required!'
      }

      if(!values.linkbtnLink){
        errors.linkbtnLink = 'Link Required!'
      }

      if(values.buybuttonLink && !validURL(values.linkbtnLink)){
        errors.linkbtnLink = 'Enter URL is Invalid.';
      }

      if(!values.linkbtn2StartTime){
        errors.linkbtn2StartTime = 'Start Time Required!'
      }

      if(!values.linkbtn2EndTime){
        errors.linkbtn2EndTime = 'End Time Required!'
      }

      if(values.linkbtn2EndTime <= values.linkbtn2StartTime){
        errors.linkbtn2EndTime = 'End time should be greater than start time.'
      }

      // console.log(Date.parse(values.annotationEndTime), parseInt(values.annotationStartTime),errors)

    }else if(type === 'linkbutton3'){
      if(!values.linkbtnText){
        errors.linkbtnText = 'Text Required!'
      }

      if(!values.linkbtnLink){
        errors.linkbtnLink = 'Link Required!'
      }

      if(values.buybuttonLink && !validURL(values.linkbtnLink)){
        errors.linkbtnLink = 'Enter URL is Invalid.';
      }

      if(!values.linkbtn3StartTime){
        errors.linkbtn3StartTime = 'Start Time Required!'
      }

      if(!values.linkbtn3EndTime){
        errors.linkbtn3EndTime = 'End Time Required!'
      }

      if(values.linkbtn3EndTime <= values.linkbtn3StartTime){
        errors.linkbtn3EndTime = 'End time should be greater than start time.'
      }

    }else if(type === 'linkbutton4'){
      if(!values.linkbtnText){
        errors.linkbtnText = 'Text Required!'
      }

      if(!values.linkbtnLink){
        errors.linkbtnLink = 'Link Required!'
      }

      if(values.buybuttonLink && !validURL(values.linkbtnLink)){
        errors.linkbtnLink = 'Enter URL is Invalid.';
      }

      if(!values.linkbtn4StartTime){
        errors.linkbtn4StartTime = 'Start Time Required!'
      }

      if(!values.linkbtn4EndTime){
        errors.linkbtn4EndTime = 'End Time Required!'
      }

      if(values.linkbtn4EndTime <= values.linkbtn4StartTime){
        errors.linkbtn4EndTime = 'End time should be greater than start time.'
      }
    }else if(type === 'linkbutton5'){
      if(!values.linkbtnText){
        errors.linkbtnText = 'Text Required!'
      }

      if(!values.linkbtnLink){
        errors.linkbtnLink = 'Link Required!'
      }

      if(values.buybuttonLink && !validURL(values.linkbtnLink)){
        errors.linkbtnLink = 'Enter URL is Invalid.';
      }

      if(!values.linkbtn5StartTime){
        errors.linkbtn5StartTime = 'Start Time Required!'
      }

      if(!values.linkbtn5EndTime){
        errors.linkbtn5EndTime = 'End Time Required!'
      }

      if(values.linkbtn5EndTime <= values.linkbtn5StartTime){
        errors.linkbtn5EndTime = 'End time should be greater than start time.'
      }
    }else if(type === 'linkbutton6'){
      if(!values.linkbtnText){
        errors.linkbtnText = 'Text Required!'
      }

      if(!values.linkbtn6StartTime){
        errors.linkbtn6StartTime = 'Start Time Required!'
      }

      if(!values.linkbtn6EndTime){
        errors.linkbtn6EndTime = 'End Time Required!'
      }

      if(values.linkbtn6EndTime <= values.linkbtn6StartTime){
        errors.linkbtn6EndTime = 'End time should be greater than start time.'
      }
    }else if(type === 'linkbutton7'){
      if(!values.linkbtnText){
        errors.linkbtnText = 'Text Required!'
      }
      if(!values.linkbtn7StartTime){
        errors.linkbtn7StartTime = 'Start Time Required!'
      }
      if(!values.linkbtn7EndTime){
        errors.linkbtn7EndTime = 'End Time Required!'
      }
      if(values.linkbtn7EndTime <= values.linkbtn7StartTime){
        errors.linkbtn7EndTime = 'End time should be greater than start time.'
      }
    }else if(type === 'linkbutton8'){
      
      if(!values.linkbtn8StartTime){
        errors.linkbtn8StartTime = 'Start Time Required!'
      }
      if(!values.linkbtn8EndTime){
        errors.linkbtn8EndTime = 'End Time Required!'
      }
      if(values.linkbtn8EndTime <= values.linkbtn8StartTime){
        errors.linkbtn8EndTime = 'End time should be greater than start time.'
      }
    }else if(type === 'linkbutton9'){
      
      if(!values.linkbtn9StartTime){
        errors.linkbtn9StartTime = 'Start Time Required!'
      }
      if(!values.linkbtn9EndTime){
        errors.linkbtn9EndTime = 'End Time Required!'
      }
      if(values.linkbtn9EndTime <= values.linkbtn9StartTime){
        errors.linkbtn9EndTime = 'End time should be greater than start time.'
      }
    }else if(type === 'Imgbutton1'){
      if(!values.ImgbtnText){
        errors.ImgbtnText = 'Text Required!'
      }

      if(!values.ImgbtnLink){
        errors.ImgbtnLink = 'Link Required!'
      }

      if(values.ImgbtnLink && !validURL(values.ImgbtnLink)){
        errors.ImgbtnLink = 'Enter URL is Invalid.';
      }

      if(!values.Imgbtn1StartTime){
        errors.Imgbtn1StartTime = 'Start Time Required!'
      }

      if(!values.Imgbtn1EndTime){
        errors.Imgbtn1EndTime = 'End Time Required!'
      }

      if(values.Imgbtn1EndTime <= values.Imgbtn1StartTime){
        errors.Imgbtn1EndTime = 'End time should be greater than start time.'
      }

      // console.log(Date.parse(values.annotationEndTime), parseInt(values.annotationStartTime),errors)

    }else if(type === 'Imgbutton2'){
      if(!values.ImgbtnText){
        errors.ImgbtnText = 'Text Required!'
      }

      if(!values.Imgbtn2StartTime){
        errors.Imgbtn2StartTime = 'Start Time Required!'
      }

      if(!values.Imgbtn2EndTime){
        errors.Imgbtn2EndTime = 'End Time Required!'
      }

      if(values.Imgbtn2EndTime <= values.Imgbtn2StartTime){
        errors.Imgbtn2EndTime = 'End time should be greater than start time.'
      }

      // console.log(Date.parse(values.annotationEndTime), parseInt(values.annotationStartTime),errors)

    }else if(type === 'Imgbutton3'){
      if(!values.ImgbtnText){
        errors.ImgbtnText = 'Text Required!'
      }

      if(!values.ImgbtnLink){
        errors.ImgbtnLink = 'Link Required!'
      }

      if(values.ImgbtnLink && !validURL(values.ImgbtnLink)){
        errors.ImgbtnLink = 'Enter URL is Invalid.';
      }

      if(!values.Imgbtn3StartTime){
        errors.Imgbtn3StartTime = 'Start Time Required!'
      }

      if(!values.Imgbtn3EndTime){
        errors.Imgbtn3EndTime = 'End Time Required!'
      }

      if(values.Imgbtn3EndTime <= values.Imgbtn3StartTime){
        errors.Imgbtn3EndTime = 'End time should be greater than start time.'
      }

      // console.log(Date.parse(values.annotationEndTime), parseInt(values.annotationStartTime),errors)

    }else if(type === 'Imgbutton4'){
      if(!values.ImgbtnText){
        errors.ImgbtnText = 'Text Required!'
      }

      if(!values.Imgbtn4StartTime){
        errors.Imgbtn4StartTime = 'Start Time Required!'
      }

      if(!values.Imgbtn4EndTime){
        errors.Imgbtn4EndTime = 'End Time Required!'
      }

      if(values.Imgbtn4EndTime <= values.Imgbtn4StartTime){
        errors.Imgbtn4EndTime = 'End time should be greater than start time.'
      }

      // console.log(Date.parse(values.annotationEndTime), parseInt(values.annotationStartTime),errors)

    }else if(type === 'Imgbutton5'){
      if(!values.ImgbtnText){
        errors.ImgbtnText = 'Text Required!'
      }

      if(!values.ImgbtnLink){
        errors.ImgbtnLink = 'Link Required!'
      }

      if(values.ImgbtnLink && !validURL(values.ImgbtnLink)){
        errors.ImgbtnLink = 'Enter URL is Invalid.';
      }

      if(!values.Imgbtn5StartTime){
        errors.Imgbtn5StartTime = 'Start Time Required!'
      }

      if(!values.Imgbtn5EndTime){
        errors.Imgbtn5EndTime = 'End Time Required!'
      }

      if(values.Imgbtn5EndTime <= values.Imgbtn5StartTime){
        errors.Imgbtn5EndTime = 'End time should be greater than start time.'
      }

    }else if(type === 'Imgbutton6'){
      if(!values.ImgbtnText){
        errors.ImgbtnText = 'Text Required!'
      }

      if(!values.Imgbtn6StartTime){
        errors.Imgbtn6StartTime = 'Start Time Required!'
      }

      if(!values.Imgbtn6EndTime){
        errors.Imgbtn6EndTime = 'End Time Required!'
      }

      if(values.Imgbtn6EndTime <= values.Imgbtn6StartTime){
        errors.Imgbtn6EndTime = 'End time should be greater than start time.'
      }

    }else if(type === 'Imgbutton7'){
      if(!values.ImgbtnText){
        errors.ImgbtnText = 'Text Required!'
      }

      if(!values.Imgbtn7StartTime){
        errors.Imgbtn7StartTime = 'Start Time Required!'
      }

      if(!values.Imgbtn7EndTime){
        errors.Imgbtn7EndTime = 'End Time Required!'
      }

      if(values.Imgbtn7EndTime <= values.Imgbtn7StartTime){
        errors.Imgbtn7EndTime = 'End time should be greater than start time.'
      }

    }else if(type === 'Imgbutton8'){
      if(!values.ImgbtnText){
        errors.ImgbtnText = 'Text Required!'
      }

      if(!values.Imgbtn8StartTime){
        errors.Imgbtn8StartTime = 'Start Time Required!'
      }

      if(!values.Imgbtn8EndTime){
        errors.Imgbtn8EndTime = 'End Time Required!'
      }

      if(values.Imgbtn8EndTime <= values.Imgbtn8StartTime){
        errors.Imgbtn8EndTime = 'End time should be greater than start time.'
      }

    }else if(type === 'copyPaste'){
      if(!values.CRMHtmlText){
        errors.CRMHtmlText = 'Please Enter Copy Paste Code here'
      }
    }else if(type === 'scriptCode'){
      if(!values.script){
        errors.script = 'Please Enter Embed Code here'
      }
    }else if(type === 'leadgenForm'){
      if(!values.headline){
        errors.headline = 'Title Required!'
      }

      if(!values.buttonname){
        errors.buttonname = 'Please Enter Button Name Here'
      }

    }else if(type === 'customPoll' || type === 'customPoll2'  || type === 'customPoll3'){
      if(!values.question){
        errors.question = 'Please Enter Your Question'
      }

      if(!values.option1){
        errors.option1 = 'Please Enter Your Option 1 Value'
      }

      if(!values.option2){
        errors.option2 = 'Please Enter Your Option 2 Value'
      }
    }else if(type === 'opentable1'){
      if(!values.opentableText){
        errors.opentableText = 'Please Enter Your Text'
      }

      
    }else if(type === 'branding'){
      if(values.player_addlink_chk && values.player_link.length === 0){
        errors.player_link = 'Please Enter your Player Link.'
      }

      if(values.player_link && !validURL(values.player_link)){
        errors.player_link = 'Enter URL is Invalid.';
      }
    }else if(type === 'privacy'){
      if(values.passwordchk && !values.passwordText){
        errors.passwordText = 'Please set password for video'
      }

      if(values.expirarychk && !values.expiraryTextTimeStamp){
        errors.expiraryText = 'Please set Expiry for video'
      }
    }else if(type === 'simple_reveal'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(!values.text2){
        errors.text2 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'speech_bubble'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'speech_bubble_2'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(!values.text2){
        errors.text2 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'speech_bubble_3'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'speech_thought'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'border_animation'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'border_animation_2'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'lt_animation_1'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'lt_animation_2' || type === 'lt_animation_3' || type === 'lt_animation_4' || type === 'lt_animation_5'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'emoji_content'){
      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }
    }else if(type === 'name_animation'){
      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }
    }

    
    console.log(errors)
    for (let error in errors) {
      // console.log(errors[error]);
      if(errors[error]){
        cuteToast({
          type: "error",
          message: errors[error],
          timer: 3000,
          title: "",
        });
      }
      
    }

    return errors;
  }

  function validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }